import React, { useCallback, useEffect, useRef, useState } from 'react';
import './index.less';

interface HeaderTabProps {
  // Define your props here
  tabs: any[];
  onHeaderMenuClick: (index: number) => void;
  activeId: number;
}

const prefix = 'HeaderTab';
let el:any=null;
const HeaderTab: React.FC<HeaderTabProps> = (props) => {
  const {tabs,activeId,onHeaderMenuClick}=props;
  const baseId='header-tab-item-';
  const timer=useRef<any>(null);
  const headerBox=useRef(null);
  const [lineStyle,setLineStyle]=useState({});
  const resizeLine = useCallback(() => {
    // console.log('header-tab resizeLine');
    if (el) {
      const rect = el.getBoundingClientRect();
      setLineStyle({
        width: rect.width + 'px',
        left: el.offsetLeft + 'px',
      });
    }
  },[])
  useEffect(()=>{
    el = document.getElementById(baseId+activeId);
    resizeLine();
  },[activeId])

  useEffect(()=>{
    const resizeObserver = new ResizeObserver((entries) => {
        // console.log('header-tab resize',entries);
        if (timer.current) {
          clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
          
          resizeLine();
        },200);
      })
    if(headerBox.current){
      resizeObserver.observe(headerBox.current);
    }
    return () => {
      resizeObserver.disconnect();
      clearTimeout(timer.current);
    }
  },[])
  return (
    <header className='header-tab'>
        <div className='header-tab-box' ref={headerBox}>
          {tabs.map((item, index) => {
          return (
            <div
              key={item.id}
              id={baseId+index}
              className={`header-item flex-center ${activeId == index ? "active" : ""}`}
              onClick={() => {
                if (activeId == index) return;
                onHeaderMenuClick(index);
              }}
            >
              {item.title}
            </div>
          );
        })}
        <div className='header-tab-line' style={lineStyle}></div>
        </div>
      </header>
  );
};

export default HeaderTab;
